module.exports = __webpack_public_path__ + "img/18.d47ca741.png";